import { SettingsSidebarLink as SettingsSidebarLinkType } from '@/types/shared/settings-sidebar/settings-sidebar-link';
import { SettingsSidebarLink } from './settings-sidebar-link';

interface SettingsSidebarProps {
  links: SettingsSidebarLinkType[];
}

export default function SettingsSidebar({ links }: SettingsSidebarProps) {
  return (
    <div className="flex flex-nowrap overflow-x-scroll no-scrollbar md:block md:overflow-auto px-3 py-6 border-b md:border-b-0 md:border-r border-gray-200 dark:border-gray-700/60 min-w-[15rem] md:space-y-3">
      <ul className="flex flex-nowrap md:block mr-3 md:mr-0">
        {links.map((link) => (
          <SettingsSidebarLink key={link.to} link={link} />
        ))}
      </ul>
    </div>
  );
}
